import validatePipelineIntegrations from 'app/shared/translation/integrations/validatePipelineIntegrations';
import translatePipelineIntegration from 'app/shared/translation/integrations/translatePipelineIntegration';

export default function translatePipelineIntegrations({ pipelineIntegrations }) {
  validatePipelineIntegrations(pipelineIntegrations);
  return pipelineIntegrations.map(translatePipelineIntegration);
}
